import { createContext } from 'react'

export const SidebarSwitchContext = createContext<{
  showDashboardMenu: boolean
  setShowDashboardMenu: (v: boolean) => void
}>({
  showDashboardMenu: false,
  setShowDashboardMenu: () => {}
})

export const isLegacySettingsPage =
  (window.location.pathname.match(
    /^\/admin\/(securite|users|agences|ftps|candidats\/change_delai|unsubscribe|signatures|templates|jobdistrib_accounts|entreprises\/(config_comptable|fichier_comptable|export)|candidats\/(fichier_comptable|import_archive)|Importxlsentreprise|dashboard\/config|dashboard\/stats|statistiques\/config|statistiques\/users|statistiques\/pilotage|statistiques\/activite|statistiques\/recrutement|push\/rechercher_offres|push\/rechercher|contracts\/export_bdc_config)|factor/
  )?.length ?? 0) > 0
